import { render, staticRenderFns } from "./profit_return_edit.vue?vue&type=template&id=daac8b58&scoped=true"
import script from "./profit_return_edit.vue?vue&type=script&lang=js"
export * from "./profit_return_edit.vue?vue&type=script&lang=js"
import style0 from "./profit_return_edit.vue?vue&type=style&index=0&id=daac8b58&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daac8b58",
  null
  
)

export default component.exports